export interface CheckListItem {
	id: number;
	name: string;
	groups: CheckListItemBase[];
	deadlineDays: number;
}

export interface CheckListGroup {
	id: number;
	name: string;
	actions: CheckListItemBase[];
}

export interface CheckListItemBase {
	name: string;
	id: number;
}

export type CheckListItemPayload = Omit<CheckListItem, 'id'>;

export type CheckListGroupPayload = Omit<CheckListGroup, 'id'>;

export interface TransportTermCheckList {
	id: number;
	transportTerm: number;
	name: string;
	groupName: string;
	status: CheckListStatus;
	note: string;
	deadline: string;
}

export type TransportTermCheckListPayload = Omit<TransportTermCheckList, 'id'>;

export enum CheckListStatus {
	TODO = 'TODO',
	IN_PROGRESS = 'IN PROGRESS',
	DONE = 'DONE',
	REJECTED = 'REJECTED',
}
